<template>
  <svg>
    <rect
      v-if="currentBbr === bbr.id"
      :x="xStart"
      :y="y"
      rx="4"
      width="200"
      height="44"
      style="fill: lightgrey; stroke-width: 2; stroke: grey"
    />
    <rect v-else :x="xStart" :y="y" rx="4" width="200" height="44" style="fill: white; stroke-width: 2; stroke: grey" />
    <text text-anchor="middle">
      <tspan :x="xStart + 100" :y="y + 20" class="subtitle-2">
        <span v-if="bbr.titel" class="pr-1">{{ bbr.titel }}</span>
        {{ bbr.nachname }}, {{ bbr.vorname }}
      </tspan>
      <tspan :x="xStart + 100" :y="y + 36" class="caption">
        {{ $filters.date(bbr.receptionsdatum, "DD.MM.YYYY") }}
      </tspan>
    </text>
    <path
      v-if="ebene > 0"
      :d="
        'M' +
        (xVater + 100) +
        ' ' +
        (yVater + 44) +
        ' C ' +
        (xVater + 100) +
        ' ' +
        (yVater + 65) +
        ' ' +
        (xStart + 100) +
        ' ' +
        (yVater + 45) +
        ' ' +
        (xStart + 100) +
        ' ' +
        (yVater + 65) +
        'L' +
        (xStart + 100) +
        ' ' +
        y
      "
      stroke="grey"
      stroke-width="2"
      fill="none"
    />
    <stammbaumKnoten
      class="mt-n2"
      v-for="(node, index) in sohn"
      :key="index"
      :sohn="node.sohn"
      :bbr="node.bbr"
      :getArrayDepth="node.getArrayDepth"
      :blatter="node.blatter"
      :ebene="ebene + 1"
      :currentBbr="currentBbr"
      :dense="dense"
      :kachelbreite="kachelbreite"
      :startJahr="startJahr"
      :xStart="calculateXStart(index, node)"
      :xMin="calculateXMin(index, node)"
      :xWidth="(xWidth / blatter) * node.blatter"
      :xVater="xStart"
      :yVater="y"
      :collapse="collapse"
    ></stammbaumKnoten>
  </svg>
</template>

<script>
  import stammbaumKnoten from "@/module/submodule/stammbaumKnotenNeu";
  export default {
    components: {
      stammbaumKnoten,
    },
    props: [
      "bbr",
      "sohn",
      "blatter",
      "ebene",
      "currentBbr",
      "dense",
      "collapse",
      "kachelbreite",
      "startJahr",
      "xStart",
      "xMin",
      "xWidth",
      "xVater",
      "yVater",
      "getArrayDepth",
    ],
    name: "stammbaumKnoten",
    data() {
      return {
        date: "",
      };
    },
    computed: {
      x() {
        console.log(this.bbr.nachname);
        console.log(this.xWidth);
        console.log(this.xStart);
        return 46;
      },
      y() {
        return this.collapse ? this.yVater + 64 : (this.bbr.receptionsdatum.substring(0, 4) - this.startJahr) * 64;
      },
      svgHeight() {
        return this.dense ? 20 : 32;
      },
      kanten() {
        let kanten = [];
        let breite = this.blatter * 2;
        let curBreite = 0;
        let abstand = this.dense ? 10 : 18;
        this.sohn.forEach((item) => {
          curBreite += item.blatter;
          kanten.push({
            x1: (this.blatter * (this.kachelbreite + abstand)) / 2,
            y1: this.y + 44 + 0,
            x2: ((this.blatter * (this.kachelbreite + abstand)) / breite) * curBreite,
            y2: this.y + 44 + this.svgHeight,
          });
          curBreite += item.blatter;
        });
        return kanten;
      },
    },
    methods: {
      calculateXStart(itemIndex, node) {
        let links = 0;
        let i = 0;
        while (i < itemIndex) {
          links = links + (this.xWidth / this.blatter) * this.sohn[i].blatter;
          i++;
        }
        // return 20
        return ((this.xWidth / this.blatter) * this.sohn[itemIndex].blatter) / 2 - 0 + links + this.xMin;
      },
      calculateXMin(itemIndex, node) {
        let links = 0;
        let i = 0;
        while (i < itemIndex) {
          links = links + (this.xWidth / this.blatter) * this.sohn[i].blatter;
          i++;
        }
        return links + this.xMin;
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// stammbaumKnotenNeu.vue?5e485a04